const DialPad = Object.freeze({
  localNumber: 'Local Number',
  diallingFrom: 'Dialling from:',
  dialedFrom: 'Dialed from:',
});

export default DialPad;
